export default __webpack_public_path__ + "static/media/Levitate D2.5 Intermediate report on innovation business model development.b3a42bf7.pdf";